import { createElement } from 'react';
import { WaiverContentType } from './waiver-content';

export const WaiverDynamicElement = ({ row }: { row: WaiverContentType }) => {
  const children = (
    <>
      {row.text} {row.children && <WaiverContentToHtml data={row.children} />}
    </>
  );

  return <>{createElement(row.element, { className: row.className ? row.className : '' }, children)}</>;
};

export const WaiverContentToHtml = ({ data }: { data: WaiverContentType[] }) => {
  return (
    <>
      {data.map((row: WaiverContentType, index: number) => (
        <WaiverDynamicElement key={index} row={row} />
      ))}
    </>
  );
};
